const opt = "/images/optimized";

export type ResponsiveImage = {
  src: string;
  width: number;
  height: number;
  sizes: string;
  webpSrcSet: string;
  avifSrcSet: string;
};

export const optimizedImages = {
  heroResort: {
    src: `${opt}/auburn-hero-main-1322.webp`,
    width: 1322,
    height: 936,
    sizes: "100vw",
    webpSrcSet: `${opt}/auburn-hero-main-768.webp 768w, ${opt}/auburn-hero-main-1100.webp 1100w, ${opt}/auburn-hero-main-1322.webp 1322w`,
    avifSrcSet: `${opt}/auburn-hero-main-768.avif 768w, ${opt}/auburn-hero-main-1100.avif 1100w, ${opt}/auburn-hero-main-1322.avif 1322w`,
  },
  storyMain: {
    src: `${opt}/auburn-welcome-sign-847.webp`,
    width: 847,
    height: 992,
    sizes: "(min-width: 1024px) 40vw, 92vw",
    webpSrcSet: `${opt}/auburn-welcome-sign-700.webp 700w, ${opt}/auburn-welcome-sign-847.webp 847w`,
    avifSrcSet: `${opt}/auburn-welcome-sign-700.avif 700w, ${opt}/auburn-welcome-sign-847.avif 847w`,
  },
  sitePullthrough: {
    src: `${opt}/auburn-pull-through-1166.webp`,
    width: 1166,
    height: 775,
    sizes: "(min-width: 1024px) 40vw, 92vw",
    webpSrcSet: `${opt}/auburn-pull-through-800.webp 800w, ${opt}/auburn-pull-through-1166.webp 1166w`,
    avifSrcSet: `${opt}/auburn-pull-through-800.avif 800w, ${opt}/auburn-pull-through-1166.avif 1166w`,
  },
  logo: {
    src: `${opt}/auburn-logo-250.webp`,
    width: 250,
    height: 150,
    sizes: "128px",
    webpSrcSet: `${opt}/auburn-logo-128.webp 128w, ${opt}/auburn-logo-250.webp 250w`,
    avifSrcSet: `${opt}/auburn-logo-128.avif 128w, ${opt}/auburn-logo-250.avif 250w`,
  },
} as const satisfies Record<string, ResponsiveImage>;

export const heroPreloadLink = {
  rel: "preload" as const,
  as: "image" as const,
  href: optimizedImages.heroResort.src,
  type: "image/webp",
  imageSrcSet: optimizedImages.heroResort.webpSrcSet,
  imageSizes: optimizedImages.heroResort.sizes,
};
